export default __webpack_public_path__ + "static/media/corsair.973040c7.webp";